export const PHONE_MASK = "+\\9\\98 (99) 999-99-99"